<template>
  <TheLayout>
    <div class="inventory-checkin" v-if="dataPermission.includes('NSH_ODM_IO_VIEW')">
      <div class="page-title title">
        <span>NHẬP KHO</span>
      </div>

      <div v-if="!isShow">
        <div class="main-content-layout data-none" v-if="itemInventory.length == 0 && !searchText">
          <div>
            <h1 class="title-no-data">Chưa có đơn nhập kho nào</h1>
            <div class="button-create-inventory">
              <el-button
                @click="btnRedirectCreate"
                class="n-btn"
                type="primary"
                v-if="dataPermission.includes('NSH_ODM_IO_CREATE')">Tạo đơn nhập kho
              </el-button>
            </div>
          </div>
        </div>
        <div v-else>
          <loading v-if="loading"></loading>
          <div class="main-content-layout">
            <div style="margin-bottom:24px" class="row px-3 d-flex justify-content-between">
              <div class="d-flex justify-content-between">
                <el-popover
                  class="mr-3"
                  v-model="filterModal"
                  placement="bottom-start"
                  width="90vw"
                  trigger="click">
                  <!-- btn -->
                  <el-button class="n-btn" type="info" slot="reference">
                    <div class="n-icon">
                      <i class="mdi mdi-filter-outline"></i>
                      Bộ lọc
                    </div>
                  </el-button>
                  <!-- content -->
                  <div class="d-flex justify-content-between">
                    <div class="filter-list">
                      <div>
                        <el-select
                          v-model="inventoryId"
                          placeholder="Kho"
                          class="m-2 el">
                          <el-option
                            v-for="item in listInventory"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id">
                          </el-option>
                        </el-select>

                        <el-select
                          v-model="statusOrder"
                          clearable
                          placeholder="Trạng thái đơn"
                          class="m-2 el">
                          <el-option
                            v-for="item in processorStatus"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </div>

                      <div>
                        <el-select
                          v-model="supplierId"
                          clearable
                          placeholder="Nhà cung cấp"
                          class="m-2 el">
                          <el-option
                            v-for="item in listSupplier"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id">
                          </el-option>
                        </el-select>

                        <el-select
                          v-model="createrId"
                          clearable
                          placeholder="Người tạo"
                          class="m-2 el">
                          <el-option
                            v-for="item in listCreater"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </div>

                      <div class="m-2 row">
                        <span class="col-4 mt-2">Ngày tạo: </span>
                        <el-date-picker
                          class="el col-8"
                          type="daterange"
                          align="right"
                          start-placeholder="Từ ngày"
                          end-placeholder="Đến ngày"
                          format="dd/MM/yyyy"
                          v-model="dateRange"
                          :clearable="false">
                        </el-date-picker>
                      </div>
                      <div class="m-2 row">
                        <span class="col-4 mt-2">Ngày cập nhật: </span>
                        <el-date-picker
                          class="el col-8"
                          type="daterange"
                          align="right"
                          start-placeholder="Từ ngày"
                          end-placeholder="Đến ngày"
                          format="dd/MM/yyyy"
                          v-model="dateRangeUpdate"
                          :clearable="false">
                        </el-date-picker>
                      </div>
                    </div>
                  </div>
                  <div class="btn-filter">
                    <BaseButton @click="searching"
                    v-if="inventoryId != '' || statusOrder != '' || supplierId != '' || createrId != '' || dateRange[0] || dateRangeUpdate[0]">Áp dụng bộ lọc</BaseButton>
                    <BaseButton variant="danger" @click="removeFilter"
                    v-if="inventoryId != '' || statusOrder != '' || supplierId != '' || createrId != '' || dateRange[0] || dateRangeUpdate[0]">Xóa bộ lọc</BaseButton>
                    <el-button class="n-btn" @click="filterModal = false">Huỷ</el-button>
                  </div>
                  <!-- <el-button style="height:44px" slot="reference" type="info" plain size=""> <i class="mdi mdi-filter-outline"></i> Bộ lọc </el-button> -->
                </el-popover>
                <div>
                  <el-input @keyup.enter.native="searching" v-model="search.textSearch" style="width:340px" placeholder="Tìm theo Mã đơn, NCC, Serial, Mã lô" clearable>
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </div>
              </div>
              <div>
                <router-link to="/storage-create">
                  <el-button class="n-btn" type="primary" v-if="dataPermission.includes('NSH_ODM_IO_CREATE')"
                   @click="btnRedirectCreate"
                    >Thêm mới đơn nhập</el-button
                  >
                </router-link>
                <!-- <BaseButton>Nhập Excel</BaseButton>
                <BaseButton>Xuất Excel</BaseButton> -->
              </div>
            </div>
            <div>
              <div
                style="max-width: 100%; width: 100%;"
                :key="updateUI"
              >
                <LayoutTable :items="itemInventory" :fields="fieldInventory.filter(e => e.show)">
                  <template #header-edit>
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style="cursor: pointer"
                      @click="showPopup('Cai-dat-hien-thi'), (visibleEditShow = true)"
                    >
                      <path
                        d="M6.16016 9.50391C6.85449 9.50391 7.4082 8.9502 7.4082 8.25586C7.4082 7.57031 6.85449 7.00781 6.16016 7.00781C5.47461 7.00781 4.91211 7.57031 4.91211 8.25586C4.91211 8.9502 5.47461 9.50391 6.16016 9.50391ZM10.291 9.09961H22.2266C22.7012 9.09961 23.0791 8.73047 23.0791 8.25586C23.0791 7.78125 22.71 7.41211 22.2266 7.41211H10.291C9.8252 7.41211 9.44727 7.78125 9.44727 8.25586C9.44727 8.73047 9.81641 9.09961 10.291 9.09961ZM6.16016 14.9092C6.85449 14.9092 7.4082 14.3555 7.4082 13.6611C7.4082 12.9756 6.85449 12.4131 6.16016 12.4131C5.47461 12.4131 4.91211 12.9756 4.91211 13.6611C4.91211 14.3555 5.47461 14.9092 6.16016 14.9092ZM10.291 14.5049H22.2266C22.7012 14.5049 23.0791 14.1357 23.0791 13.6611C23.0791 13.1865 22.71 12.8174 22.2266 12.8174H10.291C9.8252 12.8174 9.44727 13.1865 9.44727 13.6611C9.44727 14.1357 9.81641 14.5049 10.291 14.5049ZM6.16016 20.3145C6.85449 20.3145 7.4082 19.7607 7.4082 19.0664C7.4082 18.3809 6.85449 17.8184 6.16016 17.8184C5.47461 17.8184 4.91211 18.3809 4.91211 19.0664C4.91211 19.7607 5.47461 20.3145 6.16016 20.3145ZM10.291 19.9102H22.2266C22.7012 19.9102 23.0791 19.541 23.0791 19.0664C23.0791 18.5918 22.71 18.2227 22.2266 18.2227H10.291C9.8252 18.2227 9.44727 18.5918 9.44727 19.0664C9.44727 19.541 9.81641 19.9102 10.291 19.9102Z"
                        fill="#888888"
                      />
                    </svg>
                  </template>
                  <template #cell-orderNo="{ data: item }">
                    <div @click="linkTo(item.id)" style="cursor: pointer">
                      {{ item.orderNo }}
                    </div>
                  </template>
                  <template #cell-totalMoney="{ data: item }">
                    {{ item.totalMoney.toLocaleString() }}
                  </template>
                  <template #cell-totalItem="{ data: item }">
                    {{ item.totalItem.toLocaleString() }}
                  </template>
                  <template #cell-processorStatusText="{ data: item }">
                    <base-tag :type="item.processorStatusDisplay.color">{{ item.processorStatusDisplay.text }}</base-tag>
                  </template>
                  <template #cell-edit="{ data: item }">
                    <IconEditRecord
                      v-if="item.processorStatus == 'PROCESSING' || item.processorStatus == 'DRAFT'"
                      :options="optionsEditShow(itemInventory[item.index].processorStatus)"
                      @select="chooseOption($event, item)"
                    />
                      <!-- style="z-index: -1;" -->
                  </template>
                </LayoutTable>
              </div>
            </div>

            <div class="pagination-wrapper">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="search.pageSize"
              ></b-pagination>
            </div>
            <!-- <span class="float-right">Hiển thị kết quả từ {{ (currentPage - 1)*20 + 1 }} đến {{ currentPage*20 }} trên tổng {{ rows }}</span> -->
            <ItemArrangeColumn v-model="fieldInventory" />
          </div>
        </div>
      </div>
      <el-dialog
        class="n-modal"
        append-to-body
        :visible.sync="visibleCancel"
        :title="'Hủy đơn nhập kho ' + lineInfo.orderNo"
        width="600px"
        :close-on-click-modal="false"
      >
        <div class="text-align-center">
          <IconCancel />
          <p style="margin-top: 10px;">Bạn có xác nhận huỷ đơn nhập này?</p>
        </div>
        <template slot="footer">
          <el-button class="n-btn" @click="visibleCancel = false"
            >Quay lại</el-button
          >
          <el-button
            class="n-btn"
            type="danger"
            plain
            :loading="btnLoading"
            @click="btnConfirmDelOrder"
          >
            Hủy đơn
          </el-button>
        </template>
      </el-dialog>
      <el-dialog class="n-modal" append-to-body :visible.sync="visibleImport" :title="'Xác nhận đơn ' + lineInfo.orderNo" width="600px" :close-on-click-modal="false">
        <div class="text-align-center">
          <IconImport />
          <p style="margin-top: 10px;">
            Đơn được xác nhận sẽ không chỉnh sửa nội dung được nữa. <br/> Hãy chắc chắn rằng bạn đã đọc kỹ trước khi đồng ý.
          </p>
        </div>
        <template slot='footer'>
          <el-button class="n-btn" @click="visibleImport = false">Quay lại</el-button>
          <el-button class="n-btn" type='primary' :loading="btnLoading" @click="btnConfirmAction">
            Xác nhận
          </el-button>
        </template>
      </el-dialog>

      <el-dialog class="n-modal" append-to-body :visible.sync="visibleSuccess" :title="'Xác nhận nhập kho ' + lineInfo.orderNo" width="600px" :close-on-click-modal="false">
        <div class="text-align-center">
          <IconSuccess />
          <p style="margin-top: 10px;">
            <b>Dữ liệu tồn kho sẽ được cập nhật trong vài giây sau khi xác nhận.</b><br/>
            Xác nhận nhập kho và hoàn tất?
          </p>
        </div>
        <template slot='footer'>
          <el-button class="n-btn" @click="visibleSuccess = false">Quay lại</el-button>
          <el-button class="n-btn" type='primary' plain :loading="btnLoadingPrint" @click="btnConfirmAction('importAndPrintBarCode')">
            Nhập kho và in mã vạch
          </el-button>
          <el-button class="n-btn" type='primary' :loading="btnLoading" @click="btnConfirmAction">
            Xác nhận
          </el-button>
        </template>
      </el-dialog>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>
<script>
import { InventoryService } from "@/services/nextshop/inventory.service.js";
import VueCookies from "vue-cookies";
import ItemArrangeColumn from "@/pages/items/components/ItemArrangeColumn.vue";
import { SupplierServices } from "@/services/nextshop/supplier.service";
import { EmployeeService } from "@/services/nextshop/employee.service";
import { mapMutations } from "vuex";
import IconImport from '@/components/icons/icon_document_checked.vue'
import IconSuccess from '@/components/icons/icon_success.vue'
import moment from "moment";
import {
  API_BARCODE_PRINT,
  API_STORAGE_DETAIL,
  API_STORAGE_RECREATE,
  API_STORAGE_UPDATE,
} from "../../utils/contants";
import { formatHHmmDDMMYYYY } from "../../utils/format";
import { statusCheckInStorage, transferLineItemBarCode } from "../../utils/mapping";
import {
  getDataPermission,
  getLocationID,
  getMerchanIDCurrent,
  setItemBarcode,
} from "../../utils/auth";
import IconCancel from "@/components/icons/icon_cancel.vue";
import { StorageService } from "@/services/nextshop/storage.service.js";

export default {
  components: {
    ItemArrangeColumn,
    IconCancel,
    IconImport,
    IconSuccess
  },
  data() {
    return {
      visibleImport: false,
      visibleSuccess: false,
      lineInfo: {},
      visibleCancel: false,
      btnLoading: false,
      btnLoadingPrint: false,
      loading: false,
      dataPermission: getDataPermission(),
      filterModal: false,
      title: "QUẢN LÝ KHO HÀNG",
      items: [],
      showing: true,

      currentPage: 1,
      rows: 450,
      fieldInventory: [
        {
          label: "Mã đơn",
          key: "orderNo",
          show: true,
        },
        {
          label: "Mã nhà cung cấp",
          key: "codeSupplier",
          show: false,
        },
        {
          label: "Nhà cung cấp",
          key: "supplier",
          show: true,
        },
        {
          label: "SĐT của NCC",
          key: "numberSupplier",
          show: false,
        },
        {
          label: "Email NCC",
          key: "emailSupplier",
          show: false,
        },
        {
          label: "Kho nhận",
          key: "locationToCreate",
          show: true,
        },
        {
          label: "Tổng số mặt hàng",
          key: "totalVariation",
          show: false,
        },
        {
          label: "Tổng số sản phẩm",
          key: "totalItem",
          show: false,
        },
        {
          label: "Tổng tiền",
          key: "totalMoney",
          show: false,
        },
        {
          label: "Lý do nhập",
          key: "reason",
          show: false,
        },
        {
          label: "Ghi chú",
          key: "note",
          show: false,
        },
        {
          label: "Người tạo",
          key: "creator",
          show: true,
        },
        {
          label: "Người hủy",
          key: "terminator",
          show: false,
        },
        {
          label: "Tham chiếu",
          key: "reference",
          show: false,
        },
        {
          label: "Trạng thái đơn",
          key: "processorStatusText",
          show: true,
        },
        {
          label: "Thời gian tạo",
          key: "createdAt",
          show: true,
        },
        {
          label: "Thời gian cập nhật",
          key: "updatedAt",
          show: true,
        },
        {
          key: "edit",
          label: "",
          thClass: "text-right",
          show: true,
        },
      ],
      searchText: false,
      isShow: true,
      search: {
        queryString: "",
        sortBy: "id",
        sortType: "DESC",
        pageNum: "1",
        pageSize: "20",
        textSearch: "",
      },
      visibleEditshow: true,
      dragging: false,
      itemInventory: [
        {
          processorStatus: "",
          partyB: {
            resId: "",
            displayName: "",
            phoneNo: "",
            otherInfo: {
              email: "",
            },
          },
          furtherInstructions: {
            note: "",
            referenceCode: "",
            params: { employeeName: "" },
          },
          partyA: {
            displayName: "",
          },
        },
      ],

      optionsEdit: [
        { id: 0, text: "Xác nhận đơn", color: "secondary" },
        { id: 1, text: "Xem chi tiết" },
        { id: 2, text: "Sửa đơn" },
        { id: 3, text: "Đặt lại đơn" },
        { id: 4, text: "Hủy đơn", color: "danger" },
      ],
      inventoryId: "",
      listInventory: [],
      LID: getLocationID(),
      coMerchantId: getMerchanIDCurrent(),
      processorStatus: [
        { id: "DRAFT", text: "Nháp" },
        { id: "PROCESSING", text: "Đang tiến hành" },
        { id: "SUCCESS", text: "Hoàn thành" },
        { id: "CANCELED", text: "Đã hủy" },
      ],
      statusOrder: "",
      listCreater: [],
      createrId: "",
      listSupplier: [],
      supplierId: "",
      dateRange: {},
      dateRangeUpdate: {},
      updateUI: 1,
      listIdInventory: []
    };
  },
  async created() {
    await this.checkConfigInventory()
    await this.getListInventory();
    this.fetchData();
    this.getListCreater();
    this.getListSupplier();
  },
  watch: {
    currentPage() {
      this.listInventoryCheckin({ ...this.search, pageNum: this.currentPage });
    },
    lineInfo() {
      console.log(this.lineInfo);
    }
  },
  computed: {
    fieldsSelect() {
      return this.fieldInventory.filter((fil) => fil.label);
    },
    draggingInfo() {
      return this.dragging ? "" : "";
    },
    hideIcon() {
      return this.search.textSearch.length != 0;
    },
  },
  methods: {
    // call api danh sách đơn nhập
    async listInventoryCheckin(p) {
      try {
        this.loading = true;
        const response = await InventoryService.checkinInvetory(p);
        this.loading = false;
        if (response.success) {
          this.rows = response.data.totalElements;
          this.itemInventory = response.data.data.map((res) => {
            const { partyB, lineItem, furtherInstructions } = res;
            return {
              ...res,
              codeSupplier: partyB.resId,
              supplier: partyB.displayName,
              numberSupplier: partyB.phoneNo,
              locationToCreate: this.getNameLocation(res.locationToCreate),
              emailSupplier: partyB.email,
              totalVariation: lineItem.length,
              totalItem: lineItem.reduce((a, b) => {
                return a + b.quantity;
              }, 0),
              reason: furtherInstructions && furtherInstructions.length > 0 ? furtherInstructions[0].params.reason : "",
              note: furtherInstructions && furtherInstructions.length > 0 ? furtherInstructions[0].params.note : res.note,
              creator: furtherInstructions && furtherInstructions.length > 0 ? furtherInstructions[0].params.employeeName : "",
              processorStatusText: statusCheckInStorage(res.processorStatus).text,
              processorStatusDisplay: statusCheckInStorage(res.processorStatus),
              terminator: "",
              reference: "",
              createdAt: formatHHmmDDMMYYYY(res.createdAt),
              updatedAt: formatHHmmDDMMYYYY(res.updatedAt),
              furtherInstructions: {
                furtherInstructionId: "",
                key: "CHECK_IN",
                cat: "",
                note: "",
                params: {},
              },
              totalMoney: lineItem.reduce((a, b) => {
                return a + b.totalAmount;
              }, 0),
            };
          });
        }
        this.isShow = false;
      } catch (error) {
        this.isShow = false;
        console.log(error)
      }
    },
    //
    async fetchData() {
      this.search.queryString = JSON.parse(localStorage.getItem("auth.currentUser")).role == "employee" ?
      `{orderType} == '''IO''' and {furtherInstructions.key} =='''CHECK_IN''' and ({locationToCreate} =='''${VueCookies.get("LID")}''' or {furtherInstructions.params.toInventoryId} in [${this.listIdInventory}])`
      : `{orderType} == '''IO''' and {furtherInstructions.key} =='''CHECK_IN'''`
      await this.listInventoryCheckin(this.search);
    },
    // lọc
    async searching() {
      this.searchText = true;
      this.currentPage = 1;
      const queryArray = [
        "{orderType} == '''IO'''",
        "{furtherInstructions.key} =='''CHECK_IN'''",
      ];

      // nhân viên
      if (JSON.parse(localStorage.getItem("auth.currentUser")).role == "employee") {
        queryArray.push(`({locationToCreate} =='''${VueCookies.get("LID")}''' or  {furtherInstructions.params.toInventoryId} in [${this.listIdInventory}])`)
      }
      // kho
      if (this.inventoryId != "") {
        queryArray.push(
          "{furtherInstructions.params.toInventoryId} =='''" + `${this.inventoryId}` + "'''"
        );
      }

      // trạng thái đơn
      if (this.statusOrder != "") {
        queryArray.push("{processorStatus} =='''" + this.statusOrder + "'''");
      }

      // nhà cung cấp
      if (this.supplierId != "") {
        queryArray.push("{partyB.resId} =='''" + `${this.supplierId}` + "'''");
      }

      // ngày tạo
      if (this.dateRange[0] != undefined || this.dateRange[1] != undefined) {
        queryArray.push(
          "{createdAt} >= #" +
            `${moment(this.dateRange[0]).format("YYYY-MM-DD")}` +
            `T00:00:00.000Z# and {createdAt} <= #` +
            `${moment(this.dateRange[1]).format("YYYY-MM-DD")}` +
            "T23:59:59.000Z#"
        );
      }

      // người tạo
      if (this.createrId != "") {
        queryArray.push(
          "{furtherInstructions.params.employeeId} =='''" +
            `${this.createrId}` +
            "'''"
        );
      }

      // ngày cập nhật
      if (
        this.dateRangeUpdate[0] != undefined ||
        this.dateRangeUpdate[1] != undefined
      ) {
        queryArray.push(
          "{updatedAt} >= #" +
            `${moment(this.dateRangeUpdate[0]).format("YYYY-MM-DD")}` +
            `T00:00:00.000Z# and {updatedAt} <= #` +
            `${moment(this.dateRangeUpdate[1]).format("YYYY-MM-DD")}` +
            "T23:59:59.000Z#"
        );
      }
      this.search.queryString = queryArray.join(" and ");
      this.search.textSearch = this.search.textSearch.trim()
      this.filterModal = false;
      await this.listInventoryCheckin(this.search);
    },
    // xoá bộ lọc
    async removeFilter() {
      this.inventoryId = "";
      this.statusOrder = "";
      this.supplierId = "";
      this.createrId = "";
      this.dateRange = {};
      this.dateRangeUpdate = {};
      this.filterModal = false;
      await this.listInventoryCheckin({
        queryString: JSON.parse(localStorage.getItem("auth.currentUser")).role == "employee" ?
        `{orderType} == '''IO''' and {furtherInstructions.key} =='''CHECK_IN''' and ({locationToCreate} =='''${VueCookies.get("LID")}''' or  {furtherInstructions.params.toInventoryId} in [${this.listIdInventory}])` :
        "{orderType} == '''IO''' and {furtherInstructions.key} =='''CHECK_IN'''",
        sortBy: "id",
        sortType: "DESC",
        pageNum: "1",
        pageSize: this.search.pageSize,
      });
      this.searchText = true;
      this.search = {
        queryString: "",
        sortBy: "id",
        sortType: "DESC",
        pageNum: "1",
        pageSize: "20",
        textSearch: "",
      }
    },
    async removeTextSearch() {
      this.search.textSearch = "";
      await this.listInventoryCheckin(this.search);
    },
    // chuyển trang chi tiết đơn nhập
    linkTo(id) {
      this.$router.push(`${API_STORAGE_DETAIL}/${id}`);
    },
    // tạo đơn nhập
    btnRedirectCreate () {
      this.$router.push({ path: `/storage-create` });
    },
    btnConfirmAction(type) {
      if (type === 'importAndPrintBarCode') {
        this.btnLoadingPrint = true
        this.changeProcess('SUCCESS').then(res => {
          this.btnLoadingPrint = false
          if (res.success) {
            this.visibleSuccess = false
            this.updateStatus(this.lineInfo.id, "SUCCESS");
            this.$notify({
              title: 'Nhập kho thành công',
              message: 'Hàng hoá đã nhập đến kho của bạn.',
              type: 'success',
              duration: 2000
            })
          }
        })
        const items = transferLineItemBarCode(this.lineInfo.lineItem)
        setItemBarcode(items)
        this.$router.push(`${API_BARCODE_PRINT}/choose`)
        return
      }
      this.btnLoading = true
      if (this.lineInfo.processorStatus === "DRAFT") {
        this.changeProcess('PROCESSING').then(res => {
          this.btnLoading = false
          if (res.success) {
            this.visibleImport = false
            this.updateStatus(this.lineInfo.id, "PROCESSING");
            this.$notify({
              title: 'Xác nhận đơn thành công',
              message: 'Đơn nhập kho đã được xác nhận.',
              type: 'success'
            })
          }
        })
      } else if (this.lineInfo.processorStatus === "PROCESSING") {
        this.changeProcess('SUCCESS').then(res => {
          this.btnLoading = false
          if (res.success) {
            this.visibleSuccess = false
            this.updateStatus(this.lineInfo.id, "SUCCESS");
            this.$notify({
              title: 'Nhập kho thành công',
              message: 'Hàng hoá đã nhập đến kho của bạn.',
              type: 'success'
            })
          }
        })
      }
    },
    ...mapMutations({
      SET_LOADING: "item/SET_LOADING",
    }),
    btnConfirmDelOrder() {
      this.btnLoading = true;
      this.changeProcess('CANCELED').then(res => {
        this.btnLoading = false;
        if (res.success) {
          this.visibleCancel = false;
          this.$notify({
            title: "Thông báo",
            message: "Xóa phiếu thành công",
            type: "success",
          });
          // update trang thai
          this.updateStatus(this.lineInfo.id, "CANCELED");
        }
      })
    },
    updateStatus(id, status) {
      const checkIndex = this.itemInventory.findIndex((item) => item.id === id);
      if (checkIndex !== -1) {
        this.itemInventory[checkIndex] = {
          ...this.itemInventory[checkIndex],
          processorStatusText: statusCheckInStorage(status)?.text,
          processorStatusDisplay: statusCheckInStorage(status),
          processorStatus: statusCheckInStorage(status).label
        };
        this.updateUI += 1;
      }
    },
    changeProcess(statusNew) {
      return StorageService.storageChangeStatus({
        currentStatus: this.lineInfo.processorStatus,
        newStatus: statusNew,
        orderId: this.lineInfo.id,
        reason: ''
      })
    },
    
    // list kho
    async getListInventory() {
      try {
        const params = {
          coMerchantId: this.coMerchantId,
          limit: 50,
          page: 1,
          typeInventory: "NSH_ITEM_SALE",
        }
        if (JSON.parse(localStorage.getItem("auth.currentUser")).role == "employee") {
          params.coLocationId = VueCookies.get("LID")
        }
        const data = await InventoryService.inventorylist(params);
        if (data.success) {
          this.listInventory = data.data.map((e) => {
            return {
              id: e.coInventoryId,
              text: e.name,
            };
          });
          this.listIdInventory = this.listInventory.map(e => `'''${e.id}'''`).join()
        }
      } catch (error) {
        console.log(error);
      }
    },
    // list nhà cung cấp
    async getListSupplier() {
      try {
        const data = await SupplierServices.getListSupplier({
          merchantId: this.coMerchantId,
        });
        if (data.success) {
          this.listSupplier = data.data.map((e) => {
            return {
              id: e.coPartnerId,
              text: e.name,
            };
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // list ng tạo
    async getListCreater() {
      try {
        const data = await EmployeeService.listEmployeeLocation({
            merchantId: JSON.parse(localStorage.getItem("auth.currentMerchant")).id,
            locationId: JSON.parse(localStorage.getItem("LID")),
            userType: JSON.parse(localStorage.getItem("auth.currentUser")).role
        });
        if (data.success) {
          this.listCreater = data.data.map((e) => {
            return {
              id: e.coAliasUserId,
              text: e.name,
            };
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    chooseOption(data, item) {
      // Các action e để ở dưới
      this.lineInfo = item
      switch (data) {
        case "Xác nhận đơn":
          this.visibleImport = true
          // this.$router.push(`${API_STORAGE_IMPORT}/${item.id}`);
          break;
        case "Xác nhận nhập kho":
          this.visibleSuccess = true
          // this.$router.push(`${API_STORAGE_IMPORT}/${item.id}`);
          break;
        case "Sửa đơn":
          this.$router.push(`${API_STORAGE_UPDATE}/${item.id}`);
          break;
        case "Đặt lại đơn":
          this.$router.push(`${API_STORAGE_RECREATE}/${item.id}`);
          break;
        case "Hủy đơn":
          // hiển thị popup
          this.visibleCancel = true;
          break;
        default:
          break;
      }
    },
    optionsEditShow(data) {
      switch (data) {
        case "DRAFT":
          return [
            { id: 0, text: "Xác nhận đơn", color: "secondary" },
            // chi tiết đơn nhập
            { id: 2, text: "Sửa đơn" },
            // Chỉnh sửa đơn
            { id: 4, text: "Hủy đơn", color: "danger" },
            // Modal xác nhận hủy
          ];

        case "SUCCESS":
          return [
            // { id: 3, text: "Đặt lại đơn" },
            // Tạo đơn mới với dữ liệu của đơn hiện tại(Vuex)
          ];
        case "FAIL":
          return []
          // return [{ id: 3, text: "Đặt lại đơn" }];
        case "CANCELED":
          return []
          // return [{ id: 3, text: "Đặt lại đơn" }];
        case "PROCESSING":
          return [
            { id: 0, text: "Xác nhận nhập kho", color: "secondary" },
            // { id: 3, text: "Đặt lại đơn" },
            { id: 4, text: "Hủy đơn", color: "danger" },
          ];
      }
    },
  },
};
</script>

<style lang="scss">
.search-input input{
  height: 44px;
}
</style>

<style lang="scss" scoped>
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
}
.inventory-checkin {
  .input-search {
    top: 0;
    width: 300px;
    padding: 0 0 10px 0;
  }
  .title {
    padding-bottom: 18px;
  }
}

.filter-list {
  // display: inline-block;

  .storage-select {
    float: left;
    min-width: 150px;
  }
}

.data-none {
  padding: 24px;
  display: flex;
  justify-content: center;
  .title-no-data {
    font-size: 14px !important;
    padding-bottom: 16px;
  }
  .button-create-inventory {
    display: flex;
    justify-content: center;
  }
}

.btn-filter {
  padding: 8px;
  display: flex;
  justify-content: flex-start;
}

::v-deep .__input_wrap {
  background: #f2f2f2;
  padding: 8px !important;
  .__input_controls {
    background: #f2f2f2;
  }
  input.__input {
    background: #f2f2f2;
  }
  .__input::placeholder {
    color: #666666;
  }
  :last-child {
    padding: 0;
  }
}

::v-deep .el {
  background: #f2f2f2;
  i {
    color: #666666;
  }
  input {
    background: #f2f2f2;
  }
  input::placeholder {
    color: #666666;
  }
}

::v-deep table {
  tbody {
    tr {
      td {
        word-break: break-word;
      }
    }
  }
}

@media screen and(max-width: 767px) {
  .inventory-checkin {
    .header {
      display: block;
    }
    .storage-select {
      margin-bottom: 10px;
    }
  }
}
</style>
